import { render, staticRenderFns } from "./Workspace.pug?vue&type=template&id=79df6595&lang=pug&external"
import script from "./Workspace.js?vue&type=script&lang=js&external"
export * from "./Workspace.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports